import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';

// Action types
const FETCH_DROPDOWNS = 'FETCH_DROPDOWNS';
const FETCH_DROPDOWNS_COMPLETE = 'FETCH_DROPDOWNS_COMPLETE';

const DEFAULT_STATE = {
  bidTypes: [],
  jobStatuses: [],
  jobTypes: [],
  offices: [],
  salespeople: [],
  suppliers: [],
  appointmentTypes:[],
  datasheets:[],
  custoemrs:[]
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_DROPDOWNS:
      return DEFAULT_STATE;
    case FETCH_DROPDOWNS_COMPLETE:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

// Action creators
export const fetchDropdowns = () => ({
  type: FETCH_DROPDOWNS
});

const fetchDropdownsComplete = (dropdowns) => ({
  type: FETCH_DROPDOWNS_COMPLETE,
  payload: dropdowns
});

// Epics
export const fetchDropdownsEpic = (action$) => action$.pipe(
  ofType(FETCH_DROPDOWNS),
  switchMap(() => {
    const bidTypePromise = JobProApi.bidCategories.query({
      fields: 'color,displayOrder,value'
    });

    const jobStatusPromise = JobProApi.jobStatuses.query({
      fields: 'color,displayOrder,includeOnScheduler,status,value'
    });

    const jobTypesPromise = JobProApi.jobTypes.query({
      fields: 'id,color,displayOrder,name,workCapacities(capacityType,value)'
    });

    const officePromise = JobProApi.offices.query({
      fields: 'id,color,name'
    });

    const purchaseOrderStatusPromise = JobProApi.purchaseOrders.statuses.query({
      fields: 'id,displayOrder,name'
    });

    const salespeoplePromise = JobProApi.resources.query({
      isActive: true,
      isSalesperson: true
    }, {
        fields: 'id,calendarColor,firstName,lastName'
      });

    const suppliersPromise = JobProApi.suppliers.query({
      fields: 'id,name',
      limit: 999999
    });
    const appointmentTypesPromise = JobProApi.appointmentTypes.query({
      fields: 'id,name,displayOrder,color'
    })

    const datasheetsPromise = JobProApi.datasheets.query({
      fields: 'id,name',
      limit: 100
    });

    const customersPromise = JobProApi.customers.query({
      fields: 'id,name',
      limit: 100
    });

    return Promise.all([
      bidTypePromise,
      jobStatusPromise,
      jobTypesPromise,
      officePromise,
      purchaseOrderStatusPromise,
      salespeoplePromise,
      suppliersPromise,
      appointmentTypesPromise,
      datasheetsPromise,
      customersPromise
    ]).then(([bidTypes, jobStatuses, jobTypes, offices, purchaseOrderStatuses, salespeople, suppliers,appointmentTypes,datasheets,customers]) => ({
      bidTypes,
      jobStatuses: jobStatuses.filter((s) => s.includeOnScheduler),
      jobTypes,
      offices,
      purchaseOrderStatuses,
      salespeople: salespeople.map((s)=>{
        let labelKey = s.firstName + ' ' + s.lastName;
        return {...s,labelKey};    
       }
       ),
      suppliers,
      appointmentTypes,
      datasheets,
      customers
    }));
  }),
  map(fetchDropdownsComplete),
);
